import { render, staticRenderFns } from "./EDadosDoAluno.vue?vue&type=template&id=cbafac04"
import script from "./EDadosDoAluno.vue?vue&type=script&lang=js"
export * from "./EDadosDoAluno.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports